export function formatPrice(price) {
  return Number(price).toLocaleString('zh-CN', { style: 'currency', currency: 'CNY' });
}

export function isSellOut(specInfo) {
  if(specInfo.stock > 0) {
    return false;
  } else {
    return true;
  }
}

export function isWechat() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export function payOrder(router, order) {
  const id = order.id
  router.push({name:'pay-pay', params:{ id }});
}

export function getOrderStatus(enums, order) {
  if(order.orderStatus == enums.orderStatus.COMPLETED) {
    return '已完成'
  }else if(order.orderStatus == enums.orderStatus.CANCELLED){
    return '已取消'
  } else if ((order.orderStatus == enums.orderStatus.PENDING && order.refundRecord) || order.payStatus === enums.payStatus.ufunding) {
    return '退款申请中'
  } else if(order.payStatus == enums.payStatus.PAID && order.shippingStatus == enums.shippingStatus.SHIPPED){
    return '待收货'
  } else if(order.payStatus == enums.payStatus.PAID && order.refundRecord && order.refundRecord.status == 4){
    return '待买家寄回'
  } else if(order.payStatus == enums.payStatus.PAID && order.refundRecord && order.refundRecord.status == 5){
    return '买家已寄回'
  } else if (order.payStatus == enums.payStatus.PAID && order.shippingStatus == enums.shippingStatus.UNSHIPPED) {
    return '待发货'
  } else {
    return '待付款'
  }
}

export function newWorld() {
  return localStorage.getItem('activityId') == 26 ? true : false
}
